module.exports = __webpack_public_path__ + "img/map_1791458179118_63000.3a461174.jpg";